<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbUser } from '@/models/alodb/AloDbUser'
import AdminUserPassword from '@/components/admin/user/AdminUserPassword.vue'
import AdminForm from '@/components/admin/AdminForm.vue'


@Component({
  name: 'AdminUserPasswordTab', 
  components:{AdminUserPassword}
})
export default class AdminUserPasswordTab extends AdminForm<AloDbUser> {    
  get itemTypeName(){
    return "User"
  }

  get componentName(){
    return "AdminUserPassword"
  }

  get showTitle(){
    return false
  }
  
  /*Fonctions*/  
  sauvegarde() {    
    (this.$refs.formComponent as AdminUserPassword).changePassword()    
  }
  
  annuler(){
    (this.$refs.formComponent as AdminUserPassword).reset()     
  }
  
}
</script>